import React from 'react';
import { Link } from 'react-router-dom';
import { WhatsAppIcon } from '../../artwer/icons';

// Import images
import footerLogo from '../../../assets/images/artwer/logo-white-text.png';
import footerBgShape from '../../../assets/images/shapes/site-footer-two-bg-shape.png';

const WHATSAPP_NUMBER = '31616136942';

const FooterTwo = () => {
    const year = new Date().getFullYear();
    return (
        <footer className="site-footer-two">
            <div
                className="site-footer-two__bg-shape float-bob-y"
                style={{ backgroundImage: `url(${footerBgShape})` }}
            ></div>
            <div className="site-footer-two__top">
                <div className="container">
                    <div className="site-footer-two__top-inner">
                        <div className="row">
                            <div className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="100ms">
                                <div className="footer-widget-two__column footer-widget-two__about">
                                    <div className="footer-widget-two__logo">
                                        <a href="/#home">
                                            <img src={footerLogo} alt="ART-WER" />
                                        </a>
                                    </div>
                                    <p className="footer-widget-two__about-text">
                                        Balkonrenovatie, galerijvloeren en betonherstel.
                                        Een aannemingsbedrijf en eenmanszaak sinds 2012 uit
                                        Biddinghuizen — u praat direct met de vakman.
                                    </p>
                                    <div className="footer-widget-two__social">
                                        <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noreferrer" aria-label="WhatsApp"><WhatsAppIcon size={16} /></a>
                                        <a href="mailto:info@art-wer.nl" aria-label="E-mail"><span className="icon-envelope"></span></a>
                                        <a href="tel:+31616136942" aria-label="Bellen"><span className="icon-call"></span></a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms">
                                <div className="footer-widget-two__column footer-widget-two__contact">
                                    <div className="footer-widget-two__title-box">
                                        <h3 className="footer-widget-two__title">Contact</h3>
                                    </div>
                                    <div className="footer-widget-two__contact-inner">
                                        <ul className="footer-widget-two__contact-list list-unstyled">
                                            <li>
                                                <div className="icon">
                                                    <span className="icon-call"></span>
                                                </div>
                                                <div className="text">
                                                    <p><a href="tel:+31616136942">+31 6 16 13 69 42</a></p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon">
                                                    <span className="icon-envelope"></span>
                                                </div>
                                                <div className="text">
                                                    <p><a href="mailto:info@art-wer.nl">info@art-wer.nl</a></p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon">
                                                    <span className="icon-location"></span>
                                                </div>
                                                <div className="text">
                                                    <p>Lucernehof 15<br /> 8256 CH Biddinghuizen</p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="400ms">
                                <div className="footer-widget-two__column footer-widget-two__newsletter">
                                    <div className="footer-widget-two__title-box">
                                        <h3 className="footer-widget-two__title">Direct aan de slag?</h3>
                                    </div>
                                    <p className="footer-widget-two__about-text">
                                        Werkgebied: Flevoland &amp; Midden-Nederland. Vrijblijvende opname op
                                        locatie — geen wachtlijst, geen tussenpersoon.
                                    </p>
                                    <div className="footer-widget-two__btn-box" style={{ marginTop: '18px' }}>
                                        <a href="/#contact" className="thm-btn-two">
                                            Offerte aanvragen<span className="icon-dubble-arrow-right"></span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="site-footer-two__bottom">
                <div className="container">
                    <div className="site-footer-two__bottom-inner">
                        <p className="site-footer-two__bottom-text">© {year} <span className="nowrap">ART-WER</span> Aannemingsbedrijf · Eenmanszaak · KvK 54517702 · BTW NL002522645B88</p>
                        <ul className="list-unstyled site-footer-two__bottom-menu">
                            <li><a href="/#diensten">Diensten</a></li>
                            <li><a href="/#werkwijze">Werkwijze</a></li>
                            <li><a href="/#contact">Contact</a></li>
                            <li><Link to="/privacy">Privacyverklaring</Link></li>
                            <li><Link to="/voorwaarden">Algemene voorwaarden</Link></li>
                        </ul>
                    </div>
                    <p className="artwer-footer-legal">
                        Bedrijfsaansprakelijkheid verzekerd bij Nationale-Nederlanden · Wij verwerken uw
                        gegevens uitsluitend voor het uitbrengen van een offerte (AVG).
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default FooterTwo;
